import { useLocation } from "react-router-dom";

interface PageMeta {
  title: string;
  breadcrumb: { label: string; href?: string }[];
}

const pageMeta: Record<string, PageMeta> = {
  "/": {
    title: "Analytics Dashboard",
    breadcrumb: [{ label: "Task Management" }, { label: "Dashboard" }],
  },
  "/my-task": {
    title: "My Tasks",
    breadcrumb: [{ label: "Task Management" }, { label: "Task list" }],
  },
  "/my-todo": {
    title: "My Todo List",
    breadcrumb: [{ label: "Task Management" }, { label: "Todo list" }],
  },
};

export default function PageTitleBar() {
  const { pathname } = useLocation();
  const meta = pageMeta[pathname] ?? {
    title: "Work Flow",
    breadcrumb: [{ label: "Task Management" }, { label: "Work Flow" }],
  };

  return (
    <div className="flex items-center justify-between px-6 py-3 bg-transparent border-b border-slate-200">
      {/* Title */}
      <h1 className="text-lg font-bold m-0 text-violet-600">
        {meta.title}
      </h1>

      {/* Breadcrumb */}
      <nav className="flex items-center gap-1 text-xs font-medium px-3 py-1.5 rounded-full bg-violet-50 border border-violet-200">
        {meta.breadcrumb.map((crumb, i) => (
          <span key={i} className="flex items-center gap-1">
            {i > 0 && (
              <span className="text-violet-300 font-normal">/</span>
            )}
            <span
              className={
                i === meta.breadcrumb.length - 1
                  ? "text-violet-700 font-bold"
                  : "text-violet-600 font-medium"
              }
            >
              {crumb.label}
            </span>
          </span>
        ))}
      </nav>
    </div>
  );
}